import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase";
import Userauth from "../auth/js/index";

import Body from "../components/body";
import Auth from "../auth/auth";

/* Auth */
import login from "../auth/login";
import Register from "../auth/register";
import resetPassword from '../auth/reset-password.vue'

// import Register from "../pages/authentication/register_image2";

/* maintenance */
import Maintenance from "../pages/maintenance";

/* Error Pages */
import Error400 from "../errors/error_400";
import Error401 from "../errors/error_401";
import Error403 from "../errors/error_403";
import Error404 from "../errors/error_404";
import Error500 from "../errors/error_500";
import Error503 from "../errors/error_503";

/* comingsoon */
import ComingsoonSimple from "../pages/comingsoon/comingsoon_simple";
import ComingsoonImage from "../pages/comingsoon/comingsoon_image";
import ComingsoonVideo from "../pages/comingsoon/comingsoon_video";

/* Authentication */
import LoginOne from "../pages/authentication/login_one";
import LoginTwo from "../pages/authentication/login_two";
import LoginValidate from "../pages/authentication/login_with_validation";
import RegisterImage from "../pages/authentication/register_image";
import RegisterImage2 from "../pages/authentication/register_image2";
import Unlock from "../pages/authentication/unlock";
import ForgetPassword from "../pages/authentication/forget_password";
import ResetPassword from "../pages/authentication/reset_password";

//Notifier
import SendSms from "../notifier/smsManagement/sendSms"
import DynamicSms from "../notifier/smsManagement/dynamicSms"
import SmsTemplate from "../notifier/smsTemplate/smsTemplate"
import PriceAndCoverage from "../notifier/priceAndCoverage/priceAndCoverage"
import ContactGroup from "../notifier/addressBook/contactGroup"
import ManageContact from "../notifier/addressBook/manageContact"
import Billing from "../notifier/billing/billing"
import TodaysReport from "../notifier/deliveryReport/todaysDeliveryReport"
import AllReport from "../notifier/deliveryReport/allTimeDeliveryReport"
import ChangePassword from "../notifier/user/changePassword"
import ApiDocumentation from "../notifier/documentation/apiDocumentation"


//Portfolio
import blog from '../pages/portfolio/blog/blog.vue'
import collaboration from '../pages/portfolio/collaboration/collaboration.vue'
import gallery from "../pages/portfolio/gallery/gallery.vue";
import publication from "../pages/portfolio/publication/publication.vue";
import appearances from "../pages/portfolio/media/media.vue";
import contact from "../pages/portfolio/contact/contact.vue";
import recents from "../pages/portfolio/recents/recent.vue";

// Project Doc
import Dashboard from "../pages/project-doc/dashboard/dashboard.vue";
import shelterDashboard from "../pages/project-doc/dashboard/shelter-dashboard.vue";
import country from "../pages/project-doc/country/country.vue";
import district from "../pages/project-doc/district/district.vue";
import area from "../pages/project-doc/area/area.vue";
import camp from "../pages/project-doc/camp/camp.vue";
import block from "../pages/project-doc/camp/block.vue";
import assetCreate from "../pages/project-doc/asset/asset-create.vue";
import assetList from "../pages/project-doc/asset/asset.vue";
import assetEdit from "../pages/project-doc/asset/asset-edit.vue";
import assetDetail from "../pages/project-doc/asset/asset-details.vue";
import assetType from "../pages/project-doc/asset/type.vue";
import assetTypeDetail from "../pages/project-doc/asset/type-detail.vue";
import assetBulkQr from "../pages/project-doc/asset/asset-bulk-qr.vue";
import monitoringData from "../pages/project-doc/asset/monitoring-data.vue";
import adminRegister from "../pages/project-doc/admin/register.vue";
import adminList from "../pages/project-doc/admin/admin.vue";
import changePassword from "../pages/project-doc/admin/change-password.vue";

import shelter from "../pages/project-doc/shelter/shelter.vue";
import register from "../pages/project-doc/volunteer/register.vue";
import volunteerType from "../pages/project-doc/volunteer/type.vue";
import volunteer from "../pages/project-doc/volunteer/volunteer.vue";
import volunteerDetail from "../pages/project-doc/volunteer/details.vue";
import houseRegister from "../pages/project-doc/house/register.vue";
import houseList from "../pages/project-doc/house/house.vue";
import EmergencyContact from "../pages/project-doc/emergency-contacts/contacts.vue";
import reliefList from "../pages/project-doc/reliefs/reliefs.vue";
import OccupancyList from "../pages/project-doc/occupancy-summary/occupancy.vue";

import {store} from "@/store";

Vue.use(Router);

const routes = [
    // Project Doc
    {
        path: "/dashboard",
        component: Body,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "main",
                name: "dashboard",
                component: Dashboard,
                meta: {
                    title: "Dashboard"
                }
            },
            {
                path: "",
                name: "dashboard",
                component: Dashboard,
                meta: {
                    title: "Dashboard"
                }
            },
            {
                path: "shelter",
                name: "shelterDashboard",
                component: shelterDashboard,
                meta: {
                    title: "Shelter Dashboard"
                }
            }
        ]
    },

    {
        path: "/location",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "country/list",
                name: "country",
                component: country,
                meta: {
                    title: "Country"
                }
            },
            {
                path: "district/list",
                name: "district",
                component: district,
                meta: {
                    title: "District"
                }
            },
            {
                path: "area/list",
                name: "area",
                component: area,
                meta: {
                    title: "Area"
                }
            },
            {
                path: "camp/list",
                name: "camp",
                component: camp,
                meta: {
                    title: "Location (Camp)"
                }
            },
            {
                path: "block/list",
                name: "block",
                component: block,
                meta: {
                    title: "Block"
                }
            },
            {
                path: "shelter/list",
                name: "shelter",
                component: shelter,
                meta: {
                    title: "Shelter"
                }
            }
        ]
    },

    {
        path: "/volunteer",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "type",
                name: "volunteerType",
                component: volunteerType,
                meta: {
                    title: "Volunteer Type"
                }
            },
            {
                path: "register",
                name: "register",
                component: register,
                meta: {
                    title: "Register Volunteer"
                }
            },
            {
                path: "list",
                name: "volunteer",
                component: volunteer,
                meta: {
                    title: "Volunteer"
                }
            },
            {
                path: "detail/:id",
                name: "volunteerDetail",
                component: volunteerDetail,
                meta: {
                    title: "Volunteer"
                }
            }
        ]
    },

    {
        path: "/admin",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "register",
                name: "adminRegister",
                component: adminRegister,
                meta: {
                    title: "Admin Register"
                }
            },
            {
                path: "list",
                name: "adminList",
                component: adminList,
                meta: {
                    title: "Admin"
                }
            },
            {
                path: "change-password",
                name: "changePassword",
                component: changePassword,
                meta: {
                    title: "Change Password"
                }
            }
        ]
    },

    {
        path: "/house",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "register",
                name: "houseRegister",
                component: houseRegister,
                meta: {
                    title: "Register House"
                }
            },
            {
                path: "list",
                name: "houseList",
                component: houseList,
                meta: {
                    title: "House"
                }
            }
        ]
    },

    {
        path: "/resources",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "asset/create",
                name: "assetCreate",
                component: assetCreate,
                meta: {
                    title: "Asset Create"
                }
            },
            {
                path: "asset/edit/:id",
                name: "assetEdit",
                component: assetEdit,
                meta: {
                    title: "Asset Edit"
                }
            },
            {
                path: "asset/qr/list",
                name: "assetBulkQr",
                component: assetBulkQr,
                meta: {
                    title: "Asset QR"
                }
            },
            {
                path: "asset/list",
                name: "AssetList",
                component: assetList,
                meta: {
                    title: "Asset"
                }
            },
            {
                path: "asset/detail/:id",
                name: "AssetDetail",
                component: assetDetail,
                meta: {
                    title: "Asset Detail"
                }
            },
            {
                path: "monitoring-data",
                name: "MonitoringData",
                component: monitoringData,
                meta: {
                    title: "Monitoring Data"
                }
            },
            {
                path: "asset/type",
                name: "AssetType",
                component: assetType,
                meta: {
                    title: "Asset Type"
                }
            },
            {
                path: "asset/type/detail/:id",
                name: "AssetTypeDetail",
                component: assetTypeDetail,
                meta: {
                    title: "Asset Type"
                }
            },
            {
                path: "emergency-contact/list",
                name: "EmergencyContact",
                component: EmergencyContact,
                meta: {
                    title: "Emergency Contact"
                }
            },
            {
                path: "relief/list",
                name: "reliefList",
                component: reliefList,
                meta: {
                    title: "Relief"
                }
            }
        ]
    },

    {
        path: "/disasters",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "occupancy-summary",
                name: "OccupancyList",
                component: OccupancyList,
                meta: {
                    title: "Occupancy Summary"
                }
            }
        ]
    },
    



    //Portfolio
    {
        path: "/admin-portfolio",
        component: Body,
        meta: {
            requiresAuth: true,
        },
        children: [

            {
                path: "blog",
                name: "blog",
                component: blog,
                meta: {
                    title: "Blogs",
                }
            },
            {
                path: "collaboration",
                name: "collaboration",
                component: collaboration,
                meta: {
                    title: "Collaborations",
                }
            },
            {
                path: "gallery",
                name: "gallery",
                component: gallery,
                meta: {
                    title: "Gallery",
                }
            },
            {
                path: "publication",
                name: "publication",
                component: publication,
                meta: {
                    title: "Publications",
                }
            },
            {
                path: "media-appearances",
                name: "appearances",
                component: appearances,
                meta: {
                    title: "Media Appearances",
                }
            },
            {
                path: "messages",
                name: "contact",
                component: contact,
                meta: {
                    title: "Messages",
                }
            },
            {
                path: "recents",
                name: "recents",
                component: recents,
                meta: {
                    title: "Recents",
                }
            }
        ]
    },

    //Notifier
    {
        path: "/auth",
        component: Auth,
        children: [
            {
                path: "login",
                name: "Login 1",
                component: login,
                meta: {
                    title: " login",
                }
            },
            {
                path: "register",
                name: "register 1",
                component: Register,
                meta: {
                    title: " Register | Ambala",
                }
            },
            {
                path: "reset-password",
                name: "Reset Password",
                component: resetPassword,
                meta: {
                    title: " Reset Password"
                }
            }
        ]
    },

    { path: "", redirect: "/dashboard/main" },
    { path: "/dashboard", redirect: "/dashboard/main" },

    //Notifier -end
    // {
    //     path: "/dashboard",
    //     component: Body,
    //     meta: {
    //         requiresAuth: true,
    //     },
    //     children: [
    //         {
    //             path: "default",
    //             name: "default",
    //             component: Default,
    //             meta: {
    //                 title: "Default Dashboard | Cuba - Premium Admin Template",
    //             }
    //         },
    //         {
    //             path: "ecommerce",
    //             name: "ecommerce",
    //             component: Ecommerce,
    //             meta: {
    //                 title: "Ecommerce Dashboard | Cuba - Premium Admin Template",
    //             }
    //         }
    //     ],
    // },

    {
        path: "/error-400",
        name: "Error400",
        component: Error400,
        meta: {
            title: "Error400 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-401",
        name: "Error401",
        component: Error401,
        meta: {
            title: "Error401 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-403",
        name: "Error403",
        component: Error403,
        meta: {
            title: "Error403 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-404",
        name: "Error404",
        component: Error404,
        meta: {
            title: "Error404 | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/error-500",
        name: "Error500",
        component: Error500,
        meta: {
            title: "Error500 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-503",
        name: "Error503",
        component: Error503,
        meta: {
            title: "Error503 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/maintenance",
        name: "Maintenance",
        component: Maintenance,
        meta: {
            title: "Maintenance | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/comingsoon/comingsoon-simple",
        name: "ComingsoonSimple",
        component: ComingsoonSimple,
        meta: {
            title: "ComingsoonSimple | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/comingsoon/comingsoon-image",
        name: "ComingsoonImage",
        component: ComingsoonImage,
        meta: {
            title: "ComingsoonImage | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/comingsoon/comingsoon-video",
        name: "ComingsoonVideo",
        component: ComingsoonVideo,
        meta: {
            title: "ComingsoonVideo | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/login/one",
        name: "LoginOne",
        component: LoginOne,
        meta: {
            title: "LoginOne | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/login/two",
        name: "LoginTwo",
        component: LoginTwo,
        meta: {
            title: "LoginTwo | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/login/validate",
        name: "LoginValidate",
        component: LoginValidate,
        meta: {
            title: "LoginValidate | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/register/image",
        name: "RegisterImage",
        component: RegisterImage,
        meta: {
            title: "RegisterImage | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/register/image2",
        name: "RegisterImage2",
        component: RegisterImage2,
        meta: {
            title: "RegisterImage2 | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/unlockuser",
        name: "Unlock",
        component: Unlock,
        meta: {
            title: "Unlock | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/forgetpassword",
        name: "ForgetPassword",
        component: ForgetPassword,
        meta: {
            title: "ForgetPassword | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/resetpassword",
        name: "ResetPassword",
        component: ResetPassword,
        meta: {
            title: "ResetPassword | Cuba - Premium Admin Template",
        }
    }
];

const router = new Router({
    routes,
    base: process.env.BASE_URL,
    mode: "history",
    linkActiveClass: "active",
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

router.beforeEach(async (to, from, next) => {
    // console.log("started")
    if (to.meta.title) document.title = to.meta.title;
    let CurrentUser = localStorage.getItem('user') == null ? false : true;

    const allowedPaths = [
        "/auth/login",
        "/auth/register",
        "/auth/reset-password",
        "/auth/reset"
    ];

    const notAllowedWhenLoggedIn =[
        "/auth/login",
        "/auth/register",
        "/auth/reset-password",
        "/auth/reset"
    ];

    const JWTuser = localStorage.getItem("user");

    const matchPath = (path) => {
        return allowedPaths.some(allowedPath => {
            if (allowedPath.includes(":")) {
                const regexPath = allowedPath.replace(/:\w+/g, "\\w+");
                const regex = new RegExp(`^${regexPath}$`);
                return regex.test(path);
            }
            return allowedPath === path;
        });
    };

    // console.log("started22")
    // console.log(to.path)

    if ( matchPath(to.path)){
        console.log("allowed path")
        if(notAllowedWhenLoggedIn.includes(to.path)) {
            if(CurrentUser)
                return next({
                    path: '/dashboard/main',
                });
        }
        return next()
    }

    if (to.path === "/callback") {
        return next();
    }

    // Wait for the token check so a protected page never renders with an expired token
    if (CurrentUser || JWTuser) {
        const valid = await store.dispatch('authentication/verify_token', localStorage.getItem("access_token"));
        if (valid) {
            return next();
        }
    } else if (Userauth.isAuthenticatedUser()) {
        return next();
    }

    next({
        path: '/auth/login',
        query: { redirect: to.fullPath }
    });
});

export default router;
